import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://ijqjbawxcqsyotuvqtqx.supabase.co'
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlqcWpiYXd4Y3FzeW90dXZxdHF4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgwODU5NzcsImV4cCI6MjA4MzY2MTk3N30.4xGgSN__AeIBLQ2koU7KxrW7WXhVkelU8Jp_84Pr--4'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database types
export interface Project {
  id: string
  title: string
  category: string[]
  year: string
  image: string
  thumbnail?: string
  media_type?: 'image' | 'video'
  description?: string
  position: number
  created_at?: string
}

export interface ProjectsPageItem {
  id: string
  title: string
  description: string
  image: string
  link?: string
  category?: string
  button_text?: string
  button_disabled?: boolean
  position: number
  created_at?: string
}
